import {MemexColumnDataType} from '../../../../../api/columns/contracts/memex-column'
import type {SingleSelectValue} from '../../../../../api/columns/contracts/single-select'
import {asSingleSelectValue} from '../../../../../helpers/parsing'
import {sanitizeTextInputHtmlString} from '../../../../../helpers/sanitize'
import type {SingleSelectColumnModel} from '../../../../../models/column-model/custom/single-select'
import type {StatusColumnModel} from '../../../../../models/column-model/system/status'
import type {TableDataType} from '../../../table-data-type'

export const readSingleSelectCellClipboardContent = (
  row: TableDataType,
  column: SingleSelectColumnModel | StatusColumnModel,
) => {
  const customColumnValue = row.columns[column.id]
  const customValue = customColumnValue as SingleSelectValue
  const valueId = customValue?.id

  const options = column.settings.options || []
  const matchingOption = options.find(o => o.id === valueId)

  const raw = asSingleSelectValue(customColumnValue) || undefined
  const text = matchingOption?.name || ''

  return {
    text,
    dataType: MemexColumnDataType.SingleSelect,
    value: raw,
    html: matchingOption ? sanitizeTextInputHtmlString(matchingOption.nameHtml) : undefined,
  }
}
